import { Avatar, Select, SelectItem, Spinner } from "@heroui/react";
import type { Address } from "viem";
import type { TokenBalance } from "../queries/useTokenBalances";

export function L2TokenSelector({
  l2Tokens,
  tokenAddress,
  onTokenAddressChange,
}: {
  l2Tokens: TokenBalance[] | undefined;
  tokenAddress: Address;
  onTokenAddressChange: (tokenAddress: Address) => void;
}) {
  if (!l2Tokens) {
    return (
      <div className="basis-60 flex justify-center items-center">
        <Spinner />
      </div>
    );
  }

  return (
    <Select
      selectionMode="single"
      items={l2Tokens}
      selectedKeys={[tokenAddress]}
      onChange={(event) => onTokenAddressChange(event.target.value as Address)}
      radius="none"
      size="lg"
      classNames={{
        base: "basis-60 justify-center",
        innerWrapper: "px-1",
        trigger: "data-[hover=true]:bg-transparent shadow-none",
        popoverContent: "turnstile-card-border",
      }}
      renderValue={(items) =>
        items.map((item) => (
          <div className="flex gap-2 items-center" key={item.key}>
            <Avatar name={item.data?.tokenSymbol?.[0]} color="primary" classNames={{ base: "!size-6" }} />
            <span className="font-semibold">{item.data?.tokenSymbol}</span>
          </div>
        ))
      }
      aria-label="Token selector"
    >
      {(tokenData) => (
        <SelectItem key={tokenData.tokenAddress.toString()} textValue={tokenData.tokenName}>
          <div className="flex gap-2 items-center">
            <Avatar name={tokenData.tokenSymbol[0]} color="primary" classNames={{ base: "!size-6" }} />
            {tokenData.tokenSymbol}
          </div>
        </SelectItem>
      )}
    </Select>
  );
}
